import React from 'react';
import classNames from 'classnames';
import {
  FieldError,
  FieldValues,
  UseFormMethods,
  RegisterOptions,
} from 'react-hook-form';
import { get } from 'lodash';
import warningImage from '../../../assets/warning.png';
import { getValidationErrorMessage } from '../../../utils/validation';
// eslint-disable-next-line import/named
import { FlattenKeys } from '../../../types/utilTypes';
import styles from './styles.module.scss';

type Props<T extends FieldValues> = {
  className?: string;
  variant?: 'default' | 'vertical';
  label: string;
} & (
  | {
      // name is required when form is set
      name: FlattenKeys<T>;
      form: UseFormMethods<T>;
      validation?: RegisterOptions;
      // the form should control the component when it's set
      value?: undefined;
      onChange?: undefined;
    }
  | {
      name?: string;
      form?: undefined;
      // validation requires a form to be provided
      validation?: undefined;
      value?: boolean;
      onChange?: (value: boolean) => void;
    }
);

export const Toggle = <T extends FieldValues>({
  className,
  variant,
  label,
  name,
  form,
  validation,
  value,
  onChange,
}: Props<T>) => {
  const validationError = get(form?.errors, name as string) as
    | FieldError
    | undefined;
  return (
    <div className={className}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        className={classNames(
          styles.container,
          !!validationError && styles.invalid,
          variant === 'vertical' && styles.vertical,
        )}
      >
        <span className={styles.label}>{label}</span>
        <div className={styles.toggle}>
          <input
            data-testid={name}
            ref={form?.register(validation)}
            className={styles.toggleInput}
            name={name as string}
            type="checkbox"
            checked={value}
            onChange={() => onChange?.(!value)}
          />
          <span className={styles.slider} />
        </div>

        {!!validationError && (
          <>
            <div className={styles.warningIcon}>
              <img src={warningImage} alt="Warning" />
            </div>
            <span className={styles.warningText}>
              {getValidationErrorMessage(validationError)}
            </span>
          </>
        )}
      </label>
    </div>
  );
};
